import { FC, Fragment } from "react";

interface ISyntaxHighlighterProps {
  text: string;
}

const KEYWORD_PATTERNS = [
  {
    regex: /"[^"]*"/g,
    className: "keyword-string",
  },
  {
    regex:
      /\b(ROLE|CONTEXT|RAG|SOURCES OF TRUTH|ORCHESTRATION PROTOCOL|INTERNAL ONLY|SUB-AGENT ROUTING|NAME RESOLUTION|RESPONSE RULES|COMPANY CONSTRAINTS)\b/g,
    className: "keyword-primary",
  },
  {
    regex:
      /\b(ONLY|MUST|DO NOT|NEVER|ALWAYS|CRITICAL|IMPORTANT|REQUIRED|WARNING)\b/g,
    className: "keyword-emphasis",
  },
  {
    regex: /Thought:/g,
    className: "keyword-thought",
  },
  {
    regex: /\b(error|Error|ERROR|failed|Failed|FAILED)\b/g,
    className: "keyword-error",
  },
  {
    regex:
      /\b(success|Success|SUCCESS|complete|Complete|COMPLETE|finished|Finished|FINISHED)\b/g,
    className: "keyword-success",
  },
  {
    regex:
      /\b(Unauthorized|statusCode|API|endpoint|toolUse|toolResult|toolUseId|entity_type|parameter)\b/g,
    className: "keyword-technical",
  },
  {
    regex:
      /\b(Knowledge|retrieved|query|data|prompt|answer|question|action|execute|call|Action)\b/g,
    className: "keyword-action",
  },
  {
    regex: /\b(true|false|null|undefined)\b/g,
    className: "keyword-boolean",
  },
  {
    regex: /\b\d+\b/g,
    className: "keyword-number",
  },
];

export const SyntaxHighlighter: FC<ISyntaxHighlighterProps> = ({ text }) => {
  const tokens: { text: string; className?: string }[] = [];
  let lastIndex = 0;

  const allMatches: { index: number; length: number; className: string }[] = [];

  KEYWORD_PATTERNS.forEach(({ regex, className }) => {
    const resetRegex = new RegExp(regex.source, regex.flags);
    const matches = text.matchAll(resetRegex);
    for (const match of matches) {
      if (match.index !== undefined) {
        allMatches.push({
          index: match.index,
          length: match[0].length,
          className,
        });
      }
    }
  });

  allMatches.sort((a, b) => a.index - b.index);

  const nonOverlapping: typeof allMatches = [];
  let prevEnd = 0;
  allMatches.forEach(match => {
    if (match.index >= prevEnd) {
      nonOverlapping.push(match);
      prevEnd = match.index + match.length;
    }
  });

  nonOverlapping.forEach(match => {
    if (match.index > lastIndex) {
      tokens.push({ text: text.slice(lastIndex, match.index) });
    }
    tokens.push({
      text: text.slice(match.index, match.index + match.length),
      className: match.className,
    });
    lastIndex = match.index + match.length;
  });

  if (lastIndex < text.length) {
    tokens.push({ text: text.slice(lastIndex) });
  }

  return (
    <>
      {tokens.map((token, i) =>
        token.className ? (
          <span key={i} className={token.className}>
            {token.text}
          </span>
        ) : (
          <Fragment key={i}>{token.text}</Fragment>
        ),
      )}
    </>
  );
};
